import { scaffolderPlugin } from "@backstage/plugin-scaffolder";
import { createScaffolderFieldExtension } from "@backstage/plugin-scaffolder-react";
import { ListField } from "./ListField";

// @TODO: Fix the typing issues
export const ListFieldExtension: any = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: "ListField",
    component: ListField,
  })
);
